<template>
  <div class="avatar-style-none">
    <span />
  </div>
</template>

<script>
export default {
  name: 'AvatarStyleNone'
}
</script>

<style scoped lang="scss">
.avatar-style-none {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;

  span {
    // border: 2px solid #e1e8eb;
    border-radius: 9999px;
    background: #c9d7dd;
    opacity: .7;
    filter: blur(2px);
    width: 40px;
    height: 40px;
    // box-shadow: 0 2px 14px -4px rgba(0,0,0,.5);
  }
}
</style>
